import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** The Vetta V: an uneven check mark that also reads as an inverted peak. */
@Component({
  selector: 'vt-mark',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template:
    '<svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 32 32" fill="none" aria-hidden="true">' +
    '<path d="M5 10 L13.5 25 L27 5" [attr.stroke]="color()" [attr.stroke-width]="strokeWidth()" stroke-linecap="square" stroke-linejoin="miter"></path>' +
    '</svg>',
  styles: ':host { display: inline-flex; }',
})
export class VettaMarkComponent {
  readonly size = input(22);
  readonly color = input('currentColor');
  readonly strokeWidth = input(4);
}
